import { useV2CurrentAccount } from '@ferreri/minato-auth-react';
import {
  CardNavigation,
  ForumFillMediumIcon,
  GroupElementGrid,
  ImportantDevicesFillMediumIcon,
  Section,
  TitleAndDescription,
  token,
  UrnFillMediumIcon,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { routes } from 'modules/routes';

export const PetHomeServicesCardNavigationList = () => {
  const { data: account } = useV2CurrentAccount();

  const services = [
    {
      title: 'Teleconsulta veterinária',
      description:
        'Orientações, avaliação inicial e apoio para pronto atendimento.',
      Icon: ImportantDevicesFillMediumIcon,
      href: routes.accounts(account?.id as string).televeterinary,
    },
    {
      title: 'Proteção Pet',
      description:
        'Cremação ou sepultamento de cães e gatos, com teleorientação pet 24h.',
      Icon: UrnFillMediumIcon,
      href: routes.accounts(account?.id as string).cremation,
    },
    {
      title: 'Assistência Pet',
      description:
        'Assistência médica e hospitalar para cães e gatos, cremação e mais.',
      Icon: ForumFillMediumIcon,
      href: routes.accounts(account?.id as string).assistance,
    },
  ];

  return (
    <Section>
      <TitleAndDescription
        title="Assistência Veterinária"
        description="Cuidado e respeito para os pets, praticidade e conforto para os tutores."
      />
      <GroupElementGrid>
        {services.map(({ title, description, Icon, href }, index) => (
          <LinkWrapper href={href} key={index}>
            <CardNavigation
              title={title}
              description={description}
              icon={<Icon color={token.colors.solidPetPrimaryPure} />}
            />
          </LinkWrapper>
        ))}
      </GroupElementGrid>
    </Section>
  );
};
